import React from "react";
import {
  Box,
  Typography,
  Button,
  Container,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import guardImage8 from "../assets/guardnameplate.jpg";


const googleFormLink = "https://forms.gle/juQW6MV4AeVaBEMA9"; // Your Google Form

function Careers() {
  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          position: "relative",
          height: { xs: "300px", md: "500px" },
          backgroundImage: `url(${guardImage8})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          textAlign: "center",
        }}
      >
        {/* Overlay */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            bgcolor: "rgba(0,0,0,0.4)",
          }}
        />
        <Typography
          variant="h3"
          sx={{
            position: "relative",
            zIndex: 1,
            fontWeight: "bold",
            textTransform: "uppercase",
            px: 2,
          }}
        >
          Join the Lineguard Team
        </Typography>
      </Box>

      {/* Intro Section */}
      <Container sx={{ py: { xs: 6, md: 10 }, textAlign: "center" }}>
        <Typography
          variant="h4"
          sx={{ mb: 3, fontWeight: "bold", color: "#002147" }}
        >
          Start Your Security Career
        </Typography>
        <Typography
          variant="body1"
          sx={{ maxWidth: "800px", mx: "auto", mb: 4, lineHeight: 1.8 }}
        >
          At Lineguard Security, we’re always looking for motivated individuals
          to join our professional security team. We provide training, growth
          opportunities, and a supportive environment to help you succeed in
          your career.
        </Typography>
        <Button
          variant="contained"
          size="large"
          href={googleFormLink}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            bgcolor: "#ffcc00",
            color: "#000",
            fontWeight: "bold",
            px: 4,
            py: 1.5,
            mb: 6,
            borderRadius: "30px",
            "&:hover": { bgcolor: "#e6b800" },
          }}
        >
          Apply Now
        </Button>

        {/* Open Positions */}
        <Box sx={{ textAlign: "left", maxWidth: "800px", mx: "auto" }}>
          <Typography
            variant="h5"
            sx={{ mb: 3, fontWeight: "bold", color: "#002147" }}
          >
            Current Openings
          </Typography>

          {/* {[
            {
              title: "Security Guard (Residential)",
              desc: "Responsible for ensuring safety and security in residential premises. Must have strong communication skills and a commitment to professionalism.",
            },
            {
              title: "Security Guard (Commercial)",
              desc: "Provide security services in commercial properties, office complexes, and retail spaces. Experience preferred but not required.",
            },
            {
              title: "Security Supervisor",
              desc: "Supervise a team of security guards, manage schedules, and ensure compliance with company security policies.",
            },
          ].map((job, index) => (
            <Accordion key={index}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography sx={{ fontWeight: "500" }}>{job.title}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  variant="body2"
                  sx={{ lineHeight: 1.6, mb: 2 }}
                >
                  {job.desc}
                </Typography>
                <Button
                  variant="outlined"
                  href={googleFormLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    borderColor: "#002147",
                    color: "#002147",
                    fontWeight: "bold",
                    borderRadius: "25px",
                    "&:hover": { bgcolor: "#002147", color: "#fff" },
                  }}
                >
                  Apply Now
                </Button>
              </AccordionDetails>
            </Accordion>
          ))} */}
          <Typography variant="body1" sx={{ mt: 2 }}>
            No Openings at the moment. Please check back later for new
            opportunities.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Careers;
